import { render, staticRenderFns } from "./superPayPaymentClose.vue?vue&type=template&id=2b5e84fe&scoped=true&"
import script from "./superPayPaymentClose.vue?vue&type=script&lang=ts&"
export * from "./superPayPaymentClose.vue?vue&type=script&lang=ts&"
import style0 from "./superPayPaymentClose.scss?vue&type=style&index=0&id=2b5e84fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e84fe",
  null
  
)

export default component.exports